import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Property } from '../api';

export interface GetPropertyByIdRequest {
  id: string;
}

export interface UpdatePropertyRequest {
  id: string;
  propertyData: Record<string, any>;
}

export interface PropertyState {
  properties: Property[];
  currentProperty: Property | null;
  loading: boolean;
  saving: boolean;
  fetchError: string | null;
  updateError: string | null;
  lastUpdatedAt: number | null;
}

const initialState: PropertyState = {
  properties: [],
  currentProperty: null,
  loading: false,
  saving: false,
  fetchError: null,
  updateError: null,
  lastUpdatedAt: null,
};

const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    getPropertyByIdRequest: (
      state,
      _action: PayloadAction<GetPropertyByIdRequest>,
    ) => {
      state.loading = true;
      state.fetchError = null;
    },
    getPropertyByIdSuccess: (state, action: PayloadAction<Property>) => {
      state.loading = false;
      state.currentProperty = action.payload;
      state.fetchError = null;
    },
    getPropertyByIdFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.fetchError = action.payload;
    },
    updatePropertyRequest: (
      state,
      _action: PayloadAction<UpdatePropertyRequest>,
    ) => {
      state.saving = true;
      state.updateError = null;
    },
    updatePropertySuccess: (state, action: PayloadAction<Property>) => {
      state.saving = false;
      state.currentProperty = action.payload;
      state.updateError = null;
      state.lastUpdatedAt = Date.now();

      const index = state.properties.findIndex(
        property => property.id === action.payload.id,
      );
      if (index >= 0) {
        state.properties[index] = action.payload;
      }
    },
    updatePropertyFailure: (state, action: PayloadAction<string>) => {
      state.saving = false;
      state.updateError = action.payload;
    },
    setProperties: (state, action: PayloadAction<Property[]>) => {
      state.properties = action.payload;
    },
    clearCurrentProperty: state => {
      state.currentProperty = null;
    },
    clearPropertyError: state => {
      state.fetchError = null;
      state.updateError = null;
    },
    resetPropertyStatus: state => {
      state.lastUpdatedAt = null;
      state.updateError = null;
    },
  },
});

export const {
  getPropertyByIdRequest,
  getPropertyByIdSuccess,
  getPropertyByIdFailure,
  updatePropertyRequest,
  updatePropertySuccess,
  updatePropertyFailure,
  setProperties,
  clearCurrentProperty,
  clearPropertyError,
  resetPropertyStatus,
} = propertySlice.actions;

export default propertySlice.reducer;


